import { render, staticRenderFns } from "./ActivityCenter.vue?vue&type=template&id=ad347b8e&"
import script from "./ActivityCenter.vue?vue&type=script&lang=js&"
export * from "./ActivityCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports